<template>
  <div class="legal-modal-button">
    <LinkButton
      tag="button"
      type="button"
      class="legal-modal-button__button btn btn--footnote"
      :class="{ 'legal-modal-button__button--info': variant === 'info' }"
      aria-label="Fußnote"
      @click="open"
    >
      <SvgIcon
        v-if="variant === 'info'"
        :image="infoIconCircle"
        class="legal-modal-button__info-icon"
      />
      <span v-else>*</span>
    </LinkButton>
  </div>
</template>

<script setup lang="ts">
import { withDefaults, computed } from 'vue';
import { LinkButton } from '@i22/td-longtail-vue-components';
import infoIconCircle from '@/assets/images/info-icon-circle.svg';
import { openModal } from '~/composables/modal';

export type LegalModalButtonProps = {
  texts: string[];
  variant?: 'default' | 'info';
};

const props = withDefaults(defineProps<LegalModalButtonProps>(), {
  variant: 'default',
});

const getText = computed(() => `<div>${props.texts.join('</div><div>')}</div>`);

const open = (e) => {
  e.preventDefault();
  e.stopPropagation();
  openModal({
    closeOnBackdrop: true,
    content: `<div class="unstyled-html">${getText.value}</div>`,
  });
};
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.legal-modal-button {
  display: inline-block;

  &__text {
    &:last-child p:last-of-type {
      margin-bottom: 0;
    }
  }

  &__button {
    &--info {
      border: none;
      padding-top: 0;
      border-radius: 50%;

      svg {
        width: 22px;
        height: 22px;
      }
    }
  }
}
</style>
